module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "code-tips"
  }, [_c('h3', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("\n            请长按二维码关注彭州市家庭医生公众号,快捷发起家庭医生服务.若您有任何签约家庭医生相关的疑问,\n            请您联系“" + _vm._s(_vm.hospitalName) + "”咨询。电话:" + _vm._s(_vm.telephone) + "\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img",
    staticStyle: {
      "padding-top": "3.5rem",
      "padding-bottom": "1.0rem"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/success-bg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "padding-top": "1.0rem"
    }
  }, [_vm._v("签约申请提交成功")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "2.25rem"
    },
    attrs: {
      "src": require("../../../static/img/gongzonghao.jpg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5319e2be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/familyDoctor/Review.vue
// module id = 833
// module chunks = 0